"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const recoil_1 = require("recoil");
const blockFilterState_1 = __importDefault(require("./blockFilterState"));
const api_1 = require("@/api");
function default_1({ needBlockFilter, isUserInfoReady, isLoggedIn, }) {
    const setBlockFilter = (0, recoil_1.useSetRecoilState)(blockFilterState_1.default);
    const setBlockFilterReadyOnly = () => setBlockFilter({ ready: true, blockFilter: '' });
    const getBlockList = () => __awaiter(this, void 0, void 0, function* () {
        yield (0, api_1.getData)(`/api/v1/profile/block-list`)
            .then(res => {
            const blocked_ids = res.data.result.blocked_ids;
            const isBlockedIdsAvailable = !!(blocked_ids === null || blocked_ids === void 0 ? void 0 : blocked_ids.length);
            if (isBlockedIdsAvailable) {
                const base64BlockList = btoa(JSON.stringify(blocked_ids));
                setBlockFilter({ ready: true, blockFilter: base64BlockList });
            }
            else
                setBlockFilterReadyOnly();
        })
            .catch(setBlockFilterReadyOnly);
    });
    (0, react_1.useEffect)(() => {
        if (needBlockFilter && isUserInfoReady) {
            if (isLoggedIn)
                getBlockList();
            else
                setBlockFilterReadyOnly();
        }
    }, [isUserInfoReady, isLoggedIn]);
}
exports.default = default_1;
